export default __webpack_public_path__ + "media/images/carnival/apartment_sample_rj-10e4e8512ab789a6f59c20fab632aaf8.jpg";